export enum ValueTypes {
  number = 1,
  percent = 2,
}
